var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound d-flex flex-column align-self-center"},[_c('div',{staticClass:"left-slider-right flex-column justify-content-center overflow-auto"},[_c('div',{staticClass:"notfound-content d-flex flex-column"},[_c('h2',[_vm._v(_vm._s(_vm.$t("notfound.title")))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('notfound.content'))}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94fca950","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notfound.vue
// module id = 686
// module chunks = 0